document.addEventListener('DOMContentLoaded', function () {

  const loginForm = document.getElementById('auth-login');
  const forgotForm = document.getElementById('auth-forgot-password');

  const showForgotBtns = document.querySelectorAll('.js-show-forgot-password');
  const showLoginBtns = document.querySelectorAll('.js-show-login');

  showForgotBtns.forEach(btn => {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      if (loginForm) loginForm.style.display = 'none';
      if (forgotForm) forgotForm.style.display = 'block';
    });
  });

  showLoginBtns.forEach(btn => {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      if (forgotForm) forgotForm.style.display = 'none';
      if (loginForm) loginForm.style.display = 'block';
    });
  });

});